import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    annotationId: String,
    actionType: String,
    page: String,
    x: String,
    y: String,
  }

  highlight() {
    document.dispatchEvent(
      new CustomEvent("pdf-annotation:highlight-request", {
        detail: {
          annotationId: this.annotationIdValue,
          actionType: this.actionTypeValue,
          page: this.pageValue,
          x: parseFloat(this.xValue) || 0,
          y: parseFloat(this.yValue) || 0,
        },
      }),
    )
  }
}
